import React from 'react';
import { teamMembers } from '../../data/mock';

const TeamSection = () => {
  return (
    <section id="team" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[#0D2438]"></div>
      
      {/* Subtle background image - Circuit pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <img 
          src="https://images.unsplash.com/photo-1635070041078-e363dbe005cb?q=80&w=2940&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(rgba(91, 181, 197, 0.5) 1px, transparent 1px),
                          linear-gradient(90deg, rgba(91, 181, 197, 0.5) 1px, transparent 1px)`,
        backgroundSize: '50px 50px'
      }}></div>

      {/* Decorative glows */}
      <div className="absolute top-0 right-1/4 w-80 h-80 bg-[#1F7A8C]/10 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-0.5 bg-[#5BB5C5] rounded"></div>
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-widest">Our Team</p>
        </div>
        <h2 className="text-[#5BB5C5] font-semibold text-2xl lg:text-3xl mb-4 max-w-2xl">
          Leadership Team
        </h2>
        <p className="text-[#B8C8D8] text-lg mb-12 max-w-3xl">
          Our team brings deep expertise in <span className="text-[#5BB5C5]">SAP MDG</span>, <span className="text-[#5BB5C5]">S/4HANA</span>, and enterprise technology, 
          with a combined experience of over 30 years in delivering complex SAP programs.
        </p>

        {/* Team Members */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {teamMembers.map((member) => (
            <div 
              key={member.id} 
              className="bg-gradient-to-b from-[rgba(255,255,255,0.05)] to-[rgba(255,255,255,0.02)] border border-[rgba(91,181,197,0.15)] rounded-lg overflow-hidden hover:border-[rgba(91,181,197,0.3)] transition-all"
            >
              {/* Member Header */}
              <div className="bg-gradient-to-r from-[#122A40] to-[#1A3A52] p-6">
                <h3 className="text-[#E8B86D] font-semibold text-lg mb-1">
                  {member.name}
                </h3>
                <p className="text-[#5BB5C5] text-sm">
                  {member.role}
                </p>
              </div>
              
              {/* Member Content */}
              <div className="p-6">
                <p className="text-[#A8B8C8] text-sm mb-4">
                  {member.description}
                </p>
                
                {/* Expertise Tags */}
                <div className="pt-4 border-t border-[rgba(91,181,197,0.15)]">
                  <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-wider mb-3">
                    Expertise
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {member.expertise.map((skill, idx) => (
                      <span 
                        key={idx}
                        className="bg-[rgba(91,181,197,0.1)] text-[#5BB5C5] text-xs px-3 py-1 rounded border border-[rgba(91,181,197,0.2)]"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
